import { Typography } from "@mui/material";
import Calendar from "../hooks/calendar/calendar";
import { Box } from "@mui/joy";

/**
 *
 * @returns {ReactElement} Calendar page
 */
export function CalendarPage() {
  return (
    <Box sx={{ p: 2, display: "flex", flex: 1 }}>
      <Calendar />
    </Box>
  );
}
